export default __webpack_public_path__ + "static/media/New-Booking.cdf9b24f.svg";